<template>
    <section class="top-courses-section">
        <div class="custom-container">
            <div class="row align-items-center">
                <div class="col-md-12 col-lg-10 order-2 order-lg-1">
                    <slick id="courseslider" class="sslider top-courses-slider" :options="slickOptions" v-if="lstpaket.length">
                    
                            <div class="card widget-profile pat-widget-profile"  v-for="(ref) in lstpaket" :key="ref.id_paket">
                                <div class="card-body">
                                    <div class="paket-widget-content" v-bind:style="{ backgroundImage: 'url(' + ref.url_gambar + ')' }">
                                        <div class="profile-info-widget">
                                            <router-link to="" class="booking-doc-img">
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="receiver-info">
                                        <div class="btn-toolbar">
                                            <div class="btn-group btn-group-sm" style="width:80%">
                                                <button type="button" class="btn btn-secondary text-xs">{{ref.nama_tipe}}</button>
                                                <button type="button" class="btn btn-light active text-xs" v-if="ref.fg_slot == '2'"> {{ref.slot}} Slot</button>
                                            </div>
                                        </div>
                                        <div class="bg-white p-2 sm:p-4 flex flex-col justify-between sm:mt-0 mt-2">
                                            <div>
                                                <a href="" class="block">
                                                    <h3 @click.prevent="getDetail(ref)" style="min-height:100px">{{ref.nama_paket}}</h3> 
                                                    <div class="flex">
                                                        <div class="bg-danger px-2 pt-1 pb-0.5" style="width: fit-content;">
                                                            <div class="absolute -ml-2.5 -mt-0.5">
                                                                <div class="h-1 w-1 bg-white mb-0.5 rounded-full"></div> 
                                                                <div class="h-1 w-1 bg-white mb-0.5 rounded-full"></div> 
                                                                <div class="h-1 w-1 bg-white mb-0.5 rounded-full"></div>
                                                            </div> 
                                                            <p class="text-xxs text-white">HEMAT Rp{{ref.hemat}}</p>
                                                        </div>
                                                    </div> 
                                                    <div class="flex items-center mt-1">
                                                        <div class="sm:flex items-center">
                                                            <h4 class="font-medium text-xs sm:text-sm text-red-600 mr-1"><del>Rp{{ref.harga_awal}}</del></h4> 
                                                            <h3 class="font-semibold text-base text-gray-900">Rp{{ref.harga_aktif}}</h3>
                                                        </div>    
                                                    </div>
                                                    <br>
                                                
                                                </a>
                                            </div> 
                                            <div class="text-center">
                                                <btn class="btn btn-fill-blue" @click.prevent="getDetail(ref)" v-if="ref.fg_pendaftaran == '2'">
                                                    Lihat Paket
                                                </btn>
                                                <btn class="btn bg-danger-light" disabled v-if="ref.fg_pendaftaran == '1'">
                                                    Pendaftaran Berakhir
                                                </btn>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                    </slick>
                </div>
                <div class="col-md-12 col-lg-2 order-1 order-lg-2">
                    <div class="slider-section-header">
                        <!-- <br> -->
                        <h2>PAKET BELAJAR</h2>
                        <!-- <p>We are proud of our international and multi-cultural ethos, and the way our community collaborates to make a difference.</p>
                        <router-link to="/course" class="btn btn-fill">View All</router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import topcourses from '../../../assets/json/topcourses'
const courseimages = require.context('@/assets/img/courses', false, /\.png$|\.jpg$/)
const userimages = require.context('@/assets/img', false, /\.png$|\.jpg$/)

import axios from 'axios';
// import Slick from 'vue-slick';

export default {
    // components: { Slick },
    data() {
        return {
            lstpaket: [],
            topcourses: topcourses,
             slickOptions: {}
        }
    },
    created:function(){
        this.getAll();
         this.slickOptions= {
            dots: false,
            autoplay:false,
            infinite: true,
            variableWidth: false,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    },
     methods: {
         getAll: function () {
            axios.get('paketgeneral')
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
                    // this.slickOptions = {
                    //         dots: false,
                    //         autoplay:false,
                    //         infinite: true,
                    //         variableWidth: false,
                    //         slidesToShow: 4,
                    //         responsive: [
                    //             {
                    //                 breakpoint: 1024,
                    //                 settings: {
                    //                     slidesToShow: 3,
                    //                     slidesToScroll: 3
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 767,
                    //                 settings: {
                    //                     slidesToShow: 2,
                    //                     slidesToScroll: 2
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 480,
                    //                 settings: {
                    //                     slidesToShow: 1,
                    //                     slidesToScroll: 1
                    //                 }
                    //             }
                    //         ]
                    //     }
                    // this.$refs.slick({
                    //     // this.slickOptions = {
                    //         dots: false,
                    //         autoplay:false,
                    //         infinite: true,
                    //         variableWidth: false,
                    //         slidesToShow: 4,
                    //         responsive: [
                    //             {
                    //                 breakpoint: 1024,
                    //                 settings: {
                    //                     slidesToShow: 3,
                    //                     slidesToScroll: 3
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 767,
                    //                 settings: {
                    //                     slidesToShow: 2,
                    //                     slidesToScroll: 2
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 480,
                    //                 settings: {
                    //                     slidesToShow: 1,
                    //                     slidesToScroll: 1
                    //                 }
                    //             }
                    //         ]
                    //     // }
                    // });
                    
					// console.log(res.data.data);
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        getDetail: function (ref) {
            if(localStorage.getItem('idUser'))
                this.$router.push({name:'siswa-paket-belajar-detail', params: {id: ref.id_paket}});
            else
                this.$router.push({name:'home-detail-paket', params: {id: ref.id_paket}});

        },

	  loadImg(imgPath, type) {
          if(type === 1) {
              return courseimages('./' + imgPath)
          } else {
              return userimages('./' + imgPath)
          }
        
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/TopCourses/index.vue